import React, { useState } from 'react';
import { history, useIntl } from 'umi';
import { Modal, Button } from 'tea-component';
import { updateReport } from '../services';
import { ReportState } from '@user-center/enums/reports';
import { DEFAULT_REPORT } from '../constants';
import { getDBIReportListPagePath } from '@intelligence/utils/reports';
import { getReportMutationParams } from '../utils/reportParams';

export default function useReportPublish(adminMode: boolean, report: React.RefObject<IReport | null>) {
  const { formatMessage } = useIntl();

  const [loading, setLoading] = useState(false);

  const handleReportPublish = async (reportPayload: IReportPartial) => {
    setLoading(true);

    try {
      const reportNew = {
        ...DEFAULT_REPORT,
        ...report.current,
        ...reportPayload,
        state: ReportState.Published,
      };
      await updateReport(reportNew, getReportMutationParams(adminMode, reportNew));

      if (!!report.current) {
        report.current.state = ReportState.Published;
      }

      Modal.success({
        message: formatMessage({ id: 'dbu_report_publish_success_tips' }),
        description: formatMessage({ id: 'dbu_report_publish_success_tips_desc' }),
        buttons: [
          <Button
            key="btn1"
            type="primary"
            onClick={(e) => {
              e?.stopPropagation();
              const targetPath =
                getDBIReportListPagePath(report.current?.system, report.current?.source) ||
                '/intelligence/reports/insightsReports'; // fallback
              history.push(targetPath);
            }}
          >
            {formatMessage({ id: 'dbu_report_publish_success_btn1_text' })}
          </Button>,
          <Button
            key="btn2"
            onClick={(e) => {
              e?.stopPropagation();
              history.goBack();
            }}
          >
            {formatMessage({ id: 'dbu_report_publish_success_btn2_text' })}
          </Button>,
        ],
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return { reportPublishLoading: loading, onReportPublish: handleReportPublish };
}
